export const TermLifeInsurancePath = '/product/term-life-insurance/';
export const SubmitACasePath = '/activity/submit-a-case/';
export const RequestAnIllustrationPath = '/activity/request-an-illustration/';
export const IndexUniversalLifePath = '/product/index-Universal-life/';
export const AssetBasedLTCPath = '/product/Asset-Based-LTC/';
export const GuaranteedUniversalLifePath = '/product/guaranteed-universal-life/';
export const ActivityCenterDetailsPath = '/ActivityCenter/case-details';
export const ActivityCenterPath = '/ActivityCenter';
export const SPLPath = '/product/single-premium-whole-life/';
export const SIWholeLifePath = '/Products/Landing/whole-life-insurance';
export const NeedsAnalysisPath = '/insuranceTools/needsAnalysis/';
export const UniversalLifePath = '/product/universal-life/';
export const TermConversionRequestPath = '/termConversionRequest';
export const TermConversionPath = '/insuranceTools/termConversion/';
export const ProductLandingPath = '/Products/Landing/';
export const ProductPath = '/Products/';
export const PermanentLifePath = '/PermanentLife';
export const ResourceCenterPath = '/ResourceCenter';
export const PolicyReviewPath = '/PolicyReview';
export const TermReviewPath = '/Quote/TermReview/';
export const PermReviewPath = '/Quote/PermReview/';
export const ActionStatusPath = '/Action/Status';
export const SignNowPath = '/Action/SignNow';
export const ActionConsentPath = '/Action/Consent';
export const ActionSignPath = '/Action/Sign';
export const StateDisclosurePath = '/StateDisclosure';
export const UnauthorizedPath = '/unauthorized';



// WEBPACK FOOTER //
// ./src/components/Common/Products/ProductsRoute.js